import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import NotasEvaluativasView from './NotasEvaluativasView';
import * as ROUTES from '../../../../router/Routes';

const NotasEvaluativasModule = () => {
  return (
    <ContainerTemplate active={ROUTES.notasEvaluativas} routes={[ROUTES.notas]}>
      <NotasEvaluativasView />
    </ContainerTemplate>
  );
};

export default NotasEvaluativasModule;
